import BaseCommand from "@/models/api/commands/BaseCommand";

export class ChangeIssueDateCommand extends BaseCommand {
  CommandName = "ChangeIssueDate";
  Command: { Value: string };
  constructor(sessionId: string, operationId: string, value: string) {
    super(sessionId, operationId);
    this.Command = { Value: value };
  }
}
